import React from 'react';

export default class MainBanner extends React.Component {

    static propTypes = {
        text: React.PropTypes.string.isRequired,
        onChange: React.PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

    }
    componentDidMount(){
        this.initTextSpeed();
    }

    render(){
        return (
            <div className="main-banner">
                <div className="_1v5a">
                    {/*<div className="deemed-gray"></div>*/}
                    <div className="_1v5c _52jv">
                        <div className="_1v5d">사용자들과 새롭게 만나보세요</div>
                        <div id="u_0_0">
                            <div className="_1sfp">
                                앱 개발, 사업 확장, 수익 창출에 도움을 주는 <span id="texts">{this.props.text||""} </span>
                            </div>
                        </div>
                    </div>
                    <img className="_1v5b img" src="https://img1a.coupangcdn.com/image/static/travel/api/banner_5_1920.jpg" height="400" alt="" />
                </div>
            </div>
        );
    }

    initTextSpeed(){
        let text = "Ticket OpenAPI";
        let cnt = 0;
        let speed = 400; //글자가 찍히는 속도
        let timer1 = null;

        window.gogogo = ()=>{
            this.props.onChange(text.substring(0, cnt) + "_");
            cnt++;
            timer1 = setTimeout('gogogo()', speed);

            if(text.length < cnt){
                cnt = 0;
            }
        };
        gogogo();
    }
}





// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/component/MainBanner.jsx